import { Box, Link } from '@mui/material';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';

import { useTranslation } from 'common/utils/getLocalString';
import { Participant, MessageRecord } from 'components/AIAgent/types/message';

import styles from './styles.module.css';

type Props = MessageRecord;
export const Message: React.FC<Props> = props => {
  const getLocalString = useTranslation();
  const { owner, content, type } = props;

  return (
    <div
      className={clsx(styles.message, {
        [styles.agent]: owner === Participant.Agent,
        [styles.user]: owner === Participant.User,
      })}
    >
      {type === 'link' ? (
        <div>
          <div style={{ marginTop: '10px' }}>
            {getLocalString('ChatBot', 'messages', 'request')}
          </div>
          <Link
            href={content}
            target={'_blank'}
            underline='hover'
            sx={{
              '&&': {
                padding: '10px 0',
                color: '#3448FF',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                wordBreak: 'break-all',
              },
            }}
          >
            {content}
          </Link>
        </div>
      ) : (
        <ReactMarkdown
          components={{
            a: ({ href, children }) => (
              <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  color: '#3448FF',
                  fontWeight: 'bold',
                  display: 'inline-flex',
                  alignItems: 'center',
                  wordBreak: 'break-word',
                }}
              >
                {children}
              </a>
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      )}
    </div>
  );
};
